import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {actions, Form} from 'react-redux-form';
import {Col, Grid, Row} from 'react-bootstrap';
import ImageUpload from '../common/form/elements/image-upload';
import PageTitle from '../common/page-title';
import ConfirmPopup from '../common/confirm-popup';
import ArrowButton from '../common/button-arrow';
import InlineCKEditor from '../common/editor/inline-editor';
import {closeAccount, getMyProfile, saveMyProfile} from '../../actions/user';
import {loadPageContent} from '../../actions/content';

import './style.css';
import MarketingPreferences from '../about-you/marketing-preferences';
import PersonalDetails from './personal-details';
import CommunicationPreferences from '../common/form/user/communication-preferences';
import CommunicationDetails from '../common/form/user/communication-details';
import UpdateSecurity from './update-security';
import {USER_TYPE_REP, USER_TYPE_RETAILER} from '../../data/userTypes';

const logoutUrls = {
  [USER_TYPE_RETAILER]: '/logout',
  [USER_TYPE_REP]: '/team/logout',
};

class MyProfile extends Component {
  onSubmit = (payload) => {
    const payLoad = {...payload};
    const {dispatch} = this.props;

    dispatch(actions.submitFields('deep.my_profile', saveMyProfile(payLoad)));
  };
  onDelete = (result) => {
    const {dispatch} = this.props;

    this.setState({showDelete: false});
    if (result) {
      dispatch(closeAccount);
    }
  };
  onImageLoaded = (data) => {
    this.setState({image: data});
  };
  handleContentSaved = () => {
    const {dispatch} = this.props;
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };
  onCloseAccount = () => {
    this.setState({
      showDelete: !this.state.showDelete
    });
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'my-profile';
    this.state = {
      showDelete: false,
      image: ''
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getMyProfile());
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const {
      contents, user, formValid, redirectAfterDelete, area, commsMobile, commsEmail, marketingAccepted
    } = this.props;

    const {showDelete} = this.state;
    const isUserNormalLoggedIn = !user.attributes['pseudo-login'];
    const isSaveDisabled = !formValid || !isUserNormalLoggedIn;

    const logoutUrl = area ? logoutUrls[area] : logoutUrls[USER_TYPE_RETAILER];

    const profile = this.props.profile.attributes;
    const image = profile.links ? profile.links.image : undefined;

    return (
      <Grid bsClass="container" fluid className="my-profile user-inner-container">
        <Row>
          <Col className="my-profile-title" lg={12}>
            <PageTitle>
              My profile
            </PageTitle>
          </Col>
        </Row>

        <Row>
          <Col className="my-profile-editable-content" lg={12}>
            <InlineCKEditor
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${this.pageSlug}_content_text`]}
            />
          </Col>
        </Row>

        <Form model="deep.my_profile" onSubmit={payload => this.onSubmit(payload)}>
          <Row className="show-grid my-profile-details">
            <Col className="my-profile-details-image" md={4}>
              <ImageUpload
                onImageLoaded={this.onImageLoaded}
                source={image}
                sizeLimit={1024 * 1024}
                type={['image/png', 'image/jpg', 'image/jpeg']}
                upload={area === USER_TYPE_REP}
              />
            </Col>
            <Col className="my-profile-details-personal" md={5}>
              <PersonalDetails profile={profile} type={area}/>
              {area !== USER_TYPE_REP && (
              <div className="my-profile-details-personal-communication">
                <CommunicationDetails />
              </div>
              )}
            </Col>

            {isUserNormalLoggedIn && (
              <Col md={3} className="ta-righ my-profile-details-buttons">
                <UpdateSecurity type={area}/>
              </Col>
            )}
          </Row>
          {area !== USER_TYPE_REP && (
            <div>
              <hr className="light"/>

              <Row className="my-profile-marketing">
                <Col lg={12}>
                  { isUserNormalLoggedIn && (
                    <MarketingPreferences
                      title={(
                        <label>MARKETING PREFERENCES</label>
                      )}
                      type="update"
                    />
                  ) }
                </Col>
                { marketingAccepted === 'true' && (
                  <Col className="my-profile-marketing-contacts" lg={12}>
                    <CommunicationPreferences
                      commsEmail={commsEmail}
                      commsMobile={commsMobile}
                      marketing={marketingAccepted}
                      model={'deep.my_profile'}
                    />
                  </Col>
                )}
              </Row>

              <Row className="my-profile-save">
                <ArrowButton color="grey" className="pull-right" disabled={isSaveDisabled}>
                  Save
                </ArrowButton>

                {profile['user-group'] === 'staff' && (
                  <ArrowButton
                    color="red"
                    className="pull-right close-account-button"
                    arrow={false}
                    submit={false}
                    onClick={this.onCloseAccount}
                  >
                    Close account
                  </ArrowButton>
                )}

                {showDelete && (
                  <ConfirmPopup onClose={this.onDelete}>
                    <p>Are you sure you want to close your account?
                      If you close your account you will no longer be able to access <b>ignite</b>
                    </p>
                  </ConfirmPopup>
                )}

                {redirectAfterDelete && <Redirect to={logoutUrl}/>}
              </Row>
            </div>
          )}
        </Form>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.currentUser.profile,
  formValid: state.deep.forms.my_profile.$form.valid,
  redirectAfterDelete: state.currentUser.redirectAfterDelete,
  user: state.viewConfig.profile,
  contents: state.content.list,
  commsEmail: !!state.deep.my_profile.comms_email,
  commsMobile: !!state.deep.my_profile.comms_mobile,
  marketingAccepted: state.deep.my_profile.marketing_accepted
});

export default connect(mapStateToProps)(MyProfile);



// WEBPACK FOOTER //
// ./src/components/my-profile/index.jsx